import script from "./ThemePickerStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemePickerStep.vue?vue&type=script&setup=true&lang=js"

import "./ThemePickerStep.vue?vue&type=style&index=0&id=4f32a21c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f32a21c"]])

export default __exports__